$(document).on('load', () => {
	let questionBtnText = $('[data-question-toggle]').text();
	let questionFormParent = $('.questions__tabs');
	$('[data-question-toggle]').click(function() {
		if (!questionFormParent.hasClass('opened')) {
			//questionFormParent.find('.questions__tabs').slideDown(200);
			questionFormParent.addClass('opened');
			$(this).text($(this).data('question-toggle'));
		} else {
			//questionFormParent.find('.questions__tabs').slideUp(200);
			questionFormParent.removeClass('opened');
			$(this).text(questionBtnText);
		}
	});

	// Работа с табами
	let tabWrapper = $('[data-question-tabs]');
	let tabHeadItem = tabWrapper.find('.questions__tabs--title');
	let tabBodyItem = tabWrapper.find('.questions__tabs--item');
	let activeIndex = null;

	tabHeadItem.click(function(){
		if (!$(this).hasClass('active')) {
			tabHeadItem.removeClass('active');
			$(this).addClass('active')
			activeIndex = $(this).index();
			tabBodyItem.removeClass('active');
			tabBodyItem.eq(activeIndex).addClass('active');
		}
	});
});
